import React, { useEffect, useState } from "react";
import Card from "../../../../../../../common/element/Card";
import { Link } from "react-router-dom";
import BtnPrimary from "../../../../../../../common/element/Buttons/btnPrimary";
import Segment from "../../../../../../../common/element/Segment";
import Radio from "../../../../../../../common/element/Radio";
import Dialog from "../../../../../../../common/element/Dialog";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useDispatch,useSelector } from "react-redux";
import ThreeDotLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import { GetSignedUrlByKey } from "../../../../../../../actions/public/GetSignedUrlByKey";
import { GetWokerSeatPayment } from "../../../../../../../actions/provider-portal/worker/GetWokerSeatPayment";
import { SignupProviderForClient } from "../../../../../../../actions/public/SignupProviderForClient";
import BtnLight from "../../../../../../../common/element/Buttons/btnLight";
import { InviteWorker } from "../../../../../../../actions/provider-portal/worker/InviteWorker";
import useUnauthorizedHandler from "../../../../../../../common/snippet/useUnauthorizedHandler";
import { GetInvoicePdfById } from "../../../../../../../actions/provider-portal/GetInvoicePdfById";
const PaymentMethod = ({
  openUnsaveDialog,
  updateObject,
  successFunc,
  alreadyExist,
  InviteSpecificProvider,
  payAmount,
  csvData,
  onCloseNextCsv
}) => {


  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [dialogInvoice, setDialogInvoice] = useState(false);
  const dispatch = useDispatch();
  const ipAddress = useSelector((state) => state?.ipAddress?.ip);
  const stripe = useStripe();
  const [isProcessing, setIsProcessing] = useState(false);
  const elements = useElements();
  const [invocieId, setInvocieId] = useState(null);
  const [dialogIsOpen, setIsOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [error, setError] = useState(null);
  const [agree, setAgree] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [providerFees, setProviderFees] = useState(payAmount ? payAmount : "");
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));

  // PayTo State
  const [paymentMethodChoice, setPaymentMethodChoice] = useState("card"); // "card" | "payto"
  const [paytoIdType, setPaytoIdType] = useState("payid"); // "payid" | "bsb"
  const [paytoPayId, setPaytoPayId] = useState("");
  const [paytoBsb, setPaytoBsb] = useState("");
  const [paytoAccountNumber, setPaytoAccountNumber] = useState("");
  const [paytoAccountName, setPaytoAccountName] = useState("");
  const [paytoAgree, setPaytoAgree] = useState(false);

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    setError(null);
    setIsProcessing(true);

    // PayTo Payment Flow
    if (paymentMethodChoice === "payto") {
      if (paytoIdType === "payid" && !paytoPayId.trim()) {
        setIsProcessing(false);
        setError("Please enter a valid PayID (Email, Mobile, or ABN).");
        return;
      }
      if (paytoIdType === "bsb") {
        const cleanBsb = paytoBsb.replace(/[^0-9]/g, '');
        if (!cleanBsb || cleanBsb.length !== 6) {
          setIsProcessing(false);
          setError("Please enter a valid 6-digit BSB (e.g. 123-456 or 123456).");
          return;
        }
        const cleanAccount = paytoAccountNumber.trim();
        if (!cleanAccount || cleanAccount.length < 5 || cleanAccount.length > 9) {
          setIsProcessing(false);
          setError("Please enter a valid Account Number (5 to 9 digits).");
          return;
        }
      }
      if (!paytoAgree) {
        setIsProcessing(false);
        setError("Please accept the PayTo agreement terms to proceed.");
        return;
      }

      const payload = {
        ...updateObject,
        payment_method_type: "payto",
        payto_type: paytoIdType,
        payto_payid: paytoPayId.trim(),
        payto_bsb: paytoBsb.trim(),
        payto_account_number: paytoAccountNumber.trim(),
        payto_account_name: paytoAccountName.trim(),
        licence_fee: providerFees,
        saveCard: false,
      };

      dispatch(InviteSpecificProvider(payload))
        .then((response) => {
          if (response?.success) {
            const pdfData = response?.data?.xero_invoice_pdf;
            const invoiceRes = response?.data;
            setInvocieId(invoiceRes);
            if (pdfData) {
              dispatch(
                GetSignedUrlByKey({ url: pdfData }, "admin/provider")
              ).then((res) => {
                if (res?.success) {
                  setInvoiceData({
                    ...invoiceRes,
                    xero_invoice_pdf: res?.data,
                  });
                  setDialogInvoice(true);
                }
              }).finally(() => {
                setIsProcessing(false);
              });
            } else {
              setInvoiceData(invoiceRes);
              setIsProcessing(false);
              setDialogInvoice(true);
            }
          } else {
            setIsProcessing(false);
            if (response?.status === 409) {
              setError(response?.message || "This provider is already invited.");
            } else if (response?.status === 401) {
              handleUnauthorizedAccess();
            } else {
              setError(response?.message || "PayTo processing failed. Please verify your details or switch to Card.");
            }
          }
        })
        .catch((err) => {
          setIsProcessing(false);
          setError(err?.message || "Payment processing failed. Please try again.");
        });
      return;
    }

    // Card Payment Flow
    if (!stripe || !elements) {
      setIsProcessing(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { error: cardErr, token } = await stripe.createToken(cardElement);

    if (cardErr) {
      setIsProcessing(false);
      setError(cardErr.message);
      console.error(cardErr);
    } else {
      const payload = {
        ...updateObject,
        payment_method_type: "card",
        cardToken: token.id,
        licence_fee: providerFees,
        saveCard: saveCard,
      };
      
      dispatch(InviteSpecificProvider(payload))
        .then((response) => {
          if (response?.success) {
            const pdfData = response?.data?.xero_invoice_pdf;
            const invoiceRes = response?.data;
            setInvocieId(invoiceRes);
            if (pdfData) {
              dispatch(
                GetSignedUrlByKey({ url: pdfData }, "admin/provider")
              ).then((res) => {
                if (res?.success) {
                  setInvoiceData({
                    ...invoiceRes,
                    xero_invoice_pdf: res?.data,
                  });
                  setDialogInvoice(true);
                } 
              }).finally(() => {
                setIsProcessing(false);
              });
            } else {
              setInvoiceData(invoiceRes);
              setIsProcessing(false);
              setDialogInvoice(true);
            }
          } else {
            setIsProcessing(false);
            if (response?.status === 409) {
              setError(response?.message || "This provider is already invited.");
            } else if (response?.status === 401) {
              handleUnauthorizedAccess();
            } else {
              setError(response?.message || "Card payment failed.");
            }
          }
        })
        .catch((err) => {
          setIsProcessing(false);
          setError(err?.message || "Payment failed.");
        });
    }
  };

  useEffect(() => {
    if (payAmount) {
      setProviderFees(payAmount);
    }
  }, [payAmount]);

  const onCloseInvoice = () => {
    setDialogInvoice(false);
    openUnsaveDialog();
  };

  const downloadInvoice = () => {
    const pdfUrl = invoiceData?.xero_invoice_pdf || (typeof invoiceData === "string" ? invoiceData : null);
    if (pdfUrl) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `${invoiceData?.xero_invoice_number || invocieId?.xero_invoice_number || "invoice"}.pdf`;
      link.target = "_blank";
      link.click();
    } else {
      console.error("No PDF URL found in invoice data");
    }
  };

  return (
    <div className="pl-6 pr-6">
      <h5 className="text-blue-800 font-semibold text-2xl mb-2">
        Payment options
      </h5>
      <p className="text-gray-700 mb-3">
      This annual payment covers a license for one client and two included workers
      </p>
      <div>
        <div className="w-full">
          <form>
            <Card className="p-7 border border-gray-200 rounded-xl">
              {/* <h4 className="font-bold text-gray-700 text-base mb-1">Seats</h4> */}
              <h4 className="font-bold text-gray-700 text-base mb-1">
                Annual Fee (ex GST)
              </h4>
              {/* <p className="text-gray-700">$ {providerFees}</p> */}
              <p className={`flex gap-2 ${providerFees ? "text-gray-700" : "text-red-500"}`}>
                {providerFees
                  ? `$ ${providerFees}`
                  : "We couldn’t retrieve the fee information. Please try again later"}
              </p>
            </Card>
            
            <div>
              <div className="w-full">
                <form>
                  <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                    <h5 className="text-blue-800 font-semibold text-2xl mb-2">
                      Payment options
                    </h5>

                    {/* Method Selector Tabs: Card vs PayTo */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6 mt-4">
                      {/* Card Option */}
                      <div
                        onClick={() => { setPaymentMethodChoice("card"); setError(null); }}
                        className={`cursor-pointer p-4 border rounded-xl flex items-center gap-3 transition ${
                          paymentMethodChoice === "card"
                            ? "border-blue-600 bg-blue-50/50 shadow-sm ring-1 ring-blue-600"
                            : "border-gray-200 hover:border-gray-300 bg-white"
                        }`}
                      >
                        <input
                          type="radio"
                          id="method_card"
                          name="payment_choice"
                          checked={paymentMethodChoice === "card"}
                          onChange={() => { setPaymentMethodChoice("card"); setError(null); }}
                          className="text-blue-600 focus:ring-blue-500 cursor-pointer"
                        />
                        <label htmlFor="method_card" className="cursor-pointer">
                          <div className="flex items-center gap-2">
                            <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                            </svg>
                            <span className="font-semibold text-gray-900 text-sm">Credit / Debit Card</span>
                          </div>
                          <p className="text-xs text-gray-500 mt-0.5">Instant Visa, Mastercard, AMEX</p>
                        </label>
                      </div>

                      {/* PayTo Option */}
                      <div
                        onClick={() => { setPaymentMethodChoice("payto"); setError(null); }}
                        className={`cursor-pointer p-4 border rounded-xl flex items-center gap-3 transition ${
                          paymentMethodChoice === "payto"
                            ? "border-blue-600 bg-blue-50/50 shadow-sm ring-1 ring-blue-600"
                            : "border-gray-200 hover:border-gray-300 bg-white"
                        }`}
                      >
                        <input
                          type="radio"
                          id="method_payto"
                          name="payment_choice"
                          checked={paymentMethodChoice === "payto"}
                          onChange={() => { setPaymentMethodChoice("payto"); setError(null); }}
                          className="text-blue-600 focus:ring-blue-500 cursor-pointer"
                        />
                        <label htmlFor="method_payto" className="cursor-pointer">
                          <div className="flex items-center gap-2">
                            <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                            </svg>
                            <span className="font-semibold text-gray-900 text-sm">PayTo Bank Payment</span>
                            <span className="bg-blue-100 text-blue-800 text-[10px] font-bold px-1.5 py-0.5 rounded">AU NPP</span>
                          </div>
                          <p className="text-xs text-gray-500 mt-0.5">Real-time debit via PayID or BSB</p>
                        </label>
                      </div>
                    </div>

                    <div className="bg-white w-full">
                      {paymentMethodChoice === "card" ? (
                        <div className="space-y-4">
                          {/* Card Information Header */}
                          <div className="flex items-center justify-between mb-3">
                            <h2 className="text-lg font-semibold">Card Information</h2>
                            <span className="text-gray-500 text-sm font-normal flex items-center gap-2">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8 1.33334C4.3181 1.33334 1.33334 4.3181 1.33334 8C1.33334 11.6819 4.3181 14.6667 8 14.6667Z" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M8 10.6667V8" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M8 5.33334H8.00667" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              Please go to settings to change card details.
                            </span>
                          </div>

                          {/* Card Number Input */}
                          <div className="border rounded-lg p-3 focus-within:border-blue-500 transition">
                            <CardElement
                              options={{
                                hidePostalCode: true,
                                disableAutofill: true,
                                style: {
                                  base: {
                                    fontSize: "16px",
                                    color: "#333",
                                    "::placeholder": {
                                      color: "#a0aec0",
                                    },
                                  },
                                  invalid: { color: "#e53e3e" },
                                },
                              }}
                            />
                          </div>

                          {/* Agreement Checkbox */}
                          <div className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              id="terms"
                              checked={agree}
                              onChange={() => setAgree(!agree)}
                              className="cursor-pointer text-blue-600 focus:ring-blue-500"
                            />
                            <label htmlFor="terms" className="text-sm text-gray-600 cursor-pointer">
                              I understand and accept that this licensing fee is valid for 12 months
                            </label>
                          </div>

                          {/* Save card checkbox */}
                          <div className="flex items-start gap-2 mt-2">
                            <input
                              type="checkbox"
                              id="saveCard"
                              checked={saveCard}
                              onChange={() => setSaveCard(!saveCard)}
                              className="mt-1 cursor-pointer text-blue-600 focus:ring-blue-500"
                            />
                            <label htmlFor="saveCard" className="text-sm text-gray-600 cursor-pointer">
                              Save card for future payments
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-4">
                          {/* PayTo Header */}
                          <div className="flex items-center justify-between mb-2">
                            <h2 className="text-lg font-semibold text-gray-800">Australian Bank Account (PayTo)</h2>
                            <span className="text-xs text-gray-500 font-normal">Real-Time NPP Payment</span>
                          </div>

                          {/* PayID vs BSB Selector */}
                          <div className="flex gap-2 p-1 bg-gray-100 rounded-lg w-fit">
                            <button
                              type="button"
                              onClick={() => setPaytoIdType("payid")}
                              className={`px-3 py-1.5 text-xs font-semibold rounded-md transition ${
                                paytoIdType === "payid" ? "bg-white text-blue-700 shadow-sm" : "text-gray-600 hover:text-gray-900"
                              }`}
                            >
                              Pay with PayID
                            </button>
                            <button
                              type="button"
                              onClick={() => setPaytoIdType("bsb")}
                              className={`px-3 py-1.5 text-xs font-semibold rounded-md transition ${
                                paytoIdType === "bsb" ? "bg-white text-blue-700 shadow-sm" : "text-gray-600 hover:text-gray-900"
                              }`}
                            >
                              Pay with BSB & Account
                            </button>
                          </div>

                          {paytoIdType === "payid" ? (
                            <div className="space-y-3">
                              <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                  PayID (Email, Mobile, or ABN) *
                                </label>
                                <input
                                  type="text"
                                  value={paytoPayId}
                                  onChange={(e) => setPaytoPayId(e.target.value)}
                                  placeholder="e.g. billing@company.com.au or 12 345 678 901"
                                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
                                />
                              </div>
                              <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                  Account Holder Name (Optional)
                                </label>
                                <input
                                  type="text"
                                  value={paytoAccountName}
                                  onChange={(e) => setPaytoAccountName(e.target.value)}
                                  placeholder="e.g. Your Company Pty Ltd"
                                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="space-y-3">
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <div>
                                  <label className="block text-xs font-medium text-gray-700 mb-1">
                                    BSB Number *
                                  </label>
                                  <input
                                    type="text"
                                    value={paytoBsb}
                                    onChange={(e) => setPaytoBsb(e.target.value)}
                                    placeholder="e.g. 000-000"
                                    maxLength={7}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs font-medium text-gray-700 mb-1">
                                    Account Number *
                                  </label>
                                  <input
                                    type="text"
                                    value={paytoAccountNumber}
                                    onChange={(e) => setPaytoAccountNumber(e.target.value)}
                                    placeholder="e.g. 12345678"
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
                                  />
                                </div>
                              </div>
                              <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                  Account Name *
                                </label>
                                <input
                                  type="text"
                                  value={paytoAccountName}
                                  onChange={(e) => setPaytoAccountName(e.target.value)}
                                  placeholder="e.g. Your Company Pty Ltd"
                                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
                                />
                              </div>
                            </div>
                          )}

                          {/* PayTo Mandate Notice Box */}
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-900 leading-relaxed">
                            <div className="font-semibold flex items-center gap-1.5 mb-1 text-blue-950">
                              <svg className="w-4 h-4 text-blue-700 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              PayTo Agreement (Mandate) Notice
                            </div>
                            <p className="mb-1">
                              By proceeding, you agree to create a new PayTo payment mandate authorizing Conserve to debit <strong>AUD ${providerFees} (ex GST)</strong> annually from your nominated Australian bank account for the contractor licence.
                            </p>
                            <p className="text-[11px] text-blue-800 mb-1">
                              • <strong>Authorization:</strong> Please approve the mandate request in your mobile banking app or online banking when prompted.
                              <br />
                              • <strong>Management:</strong> You can view, pause, or cancel this PayTo agreement at any time in your banking app.
                              <br />
                              • <strong>Support:</strong> Questions? Contact Conserve support at <span className="font-medium">support@conserve.com.au</span> or call <span className="font-medium">1300 859 018</span>.
                            </p>
                          </div>

                          {/* PayTo Terms Agreement Checkbox */}
                          <div className="flex items-start gap-2 pt-1">
                            <input
                              type="checkbox"
                              id="paytoTerms"
                              checked={paytoAgree}
                              onChange={() => setPaytoAgree(!paytoAgree)}
                              className="mt-1 cursor-pointer text-blue-600 focus:ring-blue-500"
                            />
                            <label htmlFor="paytoTerms" className="text-xs text-gray-700 cursor-pointer">
                              I accept the PayTo terms and authorize this annual payment directly from my nominated bank account.
                            </label>
                          </div>
                        </div>
                      )}

                      {/* Error Message */}
                      {error && (
                        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start justify-between">
                          <p className="text-red-700 text-xs">{error}</p>
                          {paymentMethodChoice === "payto" && (
                            <button
                              type="button"
                              onClick={() => { setPaymentMethodChoice("card"); setError(null); }}
                              className="text-xs font-semibold text-blue-700 hover:underline ml-2 flex-shrink-0"
                            >
                              Switch to Card
                            </button>
                          )}
                        </div>
                      )}

                      {/* Submit / Action Buttons */}
                      <div className="flex mt-7 step2-btn-block form-footer justify-between">
                        <BtnLight
                          className="w-auto px-6 mr-2 flex justify-center items-center pre-step"
                          onClick={openUnsaveDialog}
                        >
                          <button type="button" className="px-6 flex justify-center items-center next-step">
                            <img
                              src="assets/icons-svg/arrow-left.svg"
                              alt=""
                              className="mr-2"
                            />{" "}
                            Cancel
                          </button>
                        </BtnLight>
                        <BtnPrimary
                          disabled={
                            isProcessing ||
                            !providerFees ||
                            (paymentMethodChoice === "card" && !agree) ||
                            (paymentMethodChoice === "payto" && (
                              !paytoAgree ||
                              (paytoIdType === "payid" && !paytoPayId.trim()) ||
                              (paytoIdType === "bsb" && (!paytoBsb.trim() || !paytoAccountNumber.trim()))
                            ))
                          }
                          className="w-auto px-6"
                          onClick={handleSubmit}
                        >
                          {isProcessing ? (
                            <div className="flex items-center gap-2">
                              <ThreeDotLoader />
                              <span className="text-xs font-normal">
                                {paymentMethodChoice === "payto" ? "Connecting to Bank..." : "Processing..."}
                              </span>
                            </div>
                          ) : (
                            paymentMethodChoice === "payto" ? "Authorize PayTo & Pay" : "Confirm and pay"
                          )}
                        </BtnPrimary>
                      </div>
                    </div>
                  </Card>
                </form>
              </div>
            </div>
          </form>
        </div>
        {/* Invoice code */}
        <Dialog
          isOpen={dialogInvoice}
          onClose={onCloseInvoice}
          onRequestClose={onCloseInvoice}
          bodyOpenClassName="overflow-hidden"
          width={720}
        >
          <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
            <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_12450_78578)">
                  <path
                    d="M19.1658 20.8745C19.9709 20.8745 20.6214 20.2225 20.6214 19.4191V15.5467C20.6214 14.7434 19.9709 14.0914 19.1658 14.0914H13.3557C12.5506 14.0914 11.9 14.7434 11.9 15.5467V19.4191C11.9 20.2225 12.5506 20.8745 13.3557 20.8745H19.1658ZM19.1658 19.5128H13.3557C13.304 19.5128 13.262 19.4707 13.262 19.4191V15.5467C13.262 15.4951 13.304 15.4531 13.3557 15.4531H19.1658C19.2174 15.4531 19.2594 15.4951 19.2594 15.5467V19.4191C19.2594 19.4707 19.2174 19.5128 19.1658 19.5128Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    d="M19.2593 15.5458C19.2593 16.0251 18.8703 16.4141 18.391 16.4141H14.1303C13.651 16.4141 13.262 16.0251 13.262 15.5458C13.262 15.1699 12.9569 14.8648 12.581 14.8648C12.2051 14.8648 11.9 15.1699 11.9 15.5458C11.9 16.7769 12.8992 17.7761 14.1303 17.7761H18.391C19.6221 17.7761 20.6213 16.7769 20.6213 15.5458C20.6213 15.1699 20.3162 14.8648 19.9403 14.8648C19.5644 14.8648 19.2593 15.1699 19.2593 15.5458Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.81 14.889C18.1307 14.889 18.391 14.6287 18.391 14.308V13.5333C18.391 12.785 17.7852 12.1777 17.0354 12.1777H15.486C14.7362 12.1777 14.1304 12.785 14.1304 13.5333V14.308C14.1304 14.6287 14.3907 14.889 14.7114 14.889H17.81ZM17.229 13.8727H15.2924V13.5333C15.2924 13.4265 15.3792 13.3397 15.486 13.3397H17.0354C17.1422 13.3397 17.229 13.4265 17.229 13.5333V13.8727Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    d="M10.78 14.0664C8.90316 14.098 5.33487 14.7346 3.56036 18.5573C3.34841 19.0142 3.38479 19.737 4.73027 19.776C6.07575 19.815 8.606 19.7923 10.166 19.776"
                    stroke="#0E4E9A"
                    stroke-width="1.95"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="11.5698"
                    cy="7.90674"
                    r="3.75986"
                    stroke="#0E4E9A"
                    stroke-width="1.95"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_12450_78578">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div>
              <h5 className="mb-0 text-gray-900 text-base font-semibold">
                {InviteSpecificProvider?.trading_name
                  ? `Connect with ${InviteSpecificProvider.trading_name}`
                  : csvData?.length === 1 && csvData[0]?.trading_name
                  ? `Connect with ${csvData[0].trading_name}`
                  : "Connect with Provider"}
              </h5>
              <p>
                Ensure a successful connection with the client by completing
                these steps
              </p>
            </div>
          </div>
          <div className="pl-4 pr-4">
            <div className="mb-5 bg-gray-50 rounded-xl border border-gray-200 p-5 rounded-xl ">
              <h3 className="mb-1 text-gray-700 font-bold text-base">
                Payment successful and invites sent to Provider!
              </h3>
              <p className="mb-4 text-gray-700">
                Thank you for your payment. A confirmation of this transaction
                has been sent to your email.
              </p>
              <h3 className="mb-1 text-gray-700 font-bold text-base">
                Invoice number{" "}
              </h3>
              <p className="mb-4 text-gray-700">
                <p>{invoiceData?.xero_invoice_number || invocieId?.xero_invoice_number || "-"}</p>
              </p>
              <button
                className="flex gap-1  text-blue-700 hover:text-blue-900 focus:text-blue-700"
                onClick={downloadInvoice}
              >
                Download invoice{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.583 13.2866V14.2866C17.583 15.6868 17.583 16.3868 17.3105 16.9216C17.0708 17.392 16.6884 17.7745 16.218 18.0141C15.6832 18.2866 14.9831 18.2866 13.583 18.2866H6.58301C5.18288 18.2866 4.48281 18.2866 3.94803 18.0141C3.47763 17.7745 3.09517 17.392 2.85549 16.9216C2.58301 16.3868 2.58301 15.6868 2.58301 14.2866V13.2866M14.2497 9.11995L10.083 13.2866M10.083 13.2866L5.91634 9.11995M10.083 13.2866V3.28662"
                    stroke="#5786CC"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="flex dailog-footer ">
            <BtnPrimary
              onClick={() => onCloseInvoice()}
              className="ml-1.5 w-auto	px-4 my-auto	ml-auto	mr-0"
            >
              Okay
            </BtnPrimary>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default PaymentMethod;

